document.addEventListener("DOMContentLoaded", function(){
    document.addEventListener('click', function(e){
        //console.log(e.target)

        const selected_variant_id = e.target.getAttribute('data-variant-id')

        if(!selected_variant_id){
            return console.log('No variant DOM element')
        }

        //console.log({selected_variant_id})

        const script_variants_data = document.querySelectorAll("script[data-js-metadata]")
        if(!script_variants_data.length === 0){
            return console.log('Cant find variants metadata')
        }

        const merged_data = []
        script_variants_data.forEach(variant => merged_data.push(JSON.parse(variant.innerHTML)))

        const variants_data = merged_data.flatMap(obj =>
            Object.entries(obj).map(([id, value]) => ({
                id,
                ...value
            }))
        );

        //console.log("meta variants data", variants_data);

        const filtered_variant = variants_data.filter(variant => variant.id === selected_variant_id)
        const { metafield_value, section_id, carat_weight} = filtered_variant[0]
        //console.log("metafield value", metafield_value, carat_weight)

        if(metafield_value === null){
            return console.log('No metafield value related to variant')
        }

        const alt_text = document.querySelector(`[data-js-section-prod-id='${section_id}']`)
        const carat_weight_anchor = document.querySelector(`[href="#carat-weight"]`)
        if(!alt_text){
            return console.log('Cant find variant DOM alt text')
        }
        
        const is_page = window.location.href.includes('/pages/');
        const time_per_page = is_page ? 500 : 1000

        if(is_page){
            setTimeout(()=>{
        
                const alt_text_page = document.querySelectorAll(`[data-js-section-prod-id='${section_id}']`)
                alt_text_page.forEach(text => text.innerText = metafield_value)
                //console.log(is_page,alt_text,carat_weight, metafield_value )

                if(!carat_weight_anchor || carat_weight === null){
                    return console.log("Cant find page variant DOM cart weight anchor or metafield value")
                }
                 const carat_weight_anchor_page = document.querySelectorAll(`[href="#carat-weight"]`)
                 carat_weight_anchor_page.forEach(text => text.innerText = carat_weight)
             }, 1000)

        }else{
            setTimeout(() => {
                alt_text.innerText = metafield_value
                if(!carat_weight_anchor || carat_weight === null){
                    return console.log("Cant find variant DOM cart weight anchor or metafield value")
                }
                carat_weight_anchor.innerText = carat_weight

            }, 1000);

        }
        


    })

})